import type { MissingSkuExportFilterItem } from '../../lib/stockImportsMissingSku'
import cn from '../MissingSkuReport.module.scss'

interface MissingSkuExportConfirmProps {
  title: string
  items: MissingSkuExportFilterItem[]
}

function MissingSkuExportConfirm({
  title,
  items,
}: MissingSkuExportConfirmProps) {
  return (
    <div>
      <p>{title}</p>
      {items.length > 0 && (
        <ul className={cn.exportFilters}>
          {items.map((item) => (
            <li key={item.label}>
              {item.label}
              {item.details && (
                <ul className={cn.exportFilterDetails}>
                  {item.details.map((detail) => (
                    <li key={detail}>{detail}</li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default MissingSkuExportConfirm
